import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { Fetch } from "../../shared/Fetch";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";

interface IProps {
  open: boolean;
  hideDialog: () => void;
  req_ID: number;
  toast: any;
}

interface IFloat_Question_Answers {
  id?: number;
  question?: string;
  answer?: string | null;
  created_On?: Date;
}

export const FloatAnswers = (props: IProps) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IFloat_Question_Answers>; loading: boolean });
  const [loading, setLoading] = useState<boolean>(false);
  const dt = useRef<any>(null);

  const onHide = () => {
    props.hideDialog();
  };
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;

  const header = () => <></>;

  const getQuestionAnswers = async (reqID: number) => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Float/getFloatAsnwers", "GET", null, `reqID=${reqID}`, props.toast);
    if (response) {
      const data: IFloat_Question_Answers[] = await response.json();
      setTableData({ tableData: data, loading: false });
    } else setTableData({ tableData: tableData.tableData, loading: false });
  };

  useEffect(() => {
    if (props.open && props.req_ID) {
      getQuestionAnswers(props.req_ID);
    }
  }, [props.open]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="Requirement Float Questionnaire" modal className="p-fluid" onHide={onHide}>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        ref={dt}
        size="small"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        value={tableData.tableData}
        emptyMessage="No Records found."
        header={header}
        loading={tableData.loading}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
        <Column field="question" header="Question" />
        <Column field="answer" header="Answer" />
        <Column field="created_On" header="Answered On" body={(rowData: any) => safeFormatDate(rowData.created_On, "dd/MM/yyyy", DateFormat, true)} />
      </DataTable>
    </Dialog>
  );
};
